import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  LinearProgress,
  Skeleton,
  Stack,
  Typography,
} from '@all-manager/design-system-v2';
import { useAiUsageCard } from './useAiUsageCard';

type Props = {
  spaceId: string;
};

const SKELETON_HEIGHT = 64;

export default function AiUsageCard(props: Props) {
  const hook = useAiUsageCard(props);

  function renderContent() {
    if (hook.isLoading) {
      return <Skeleton variant="rounded" height={SKELETON_HEIGHT} />;
    }

    if (hook.hasError) {
      return <Alert severity="error">La consommation IA n'a pas pu être chargée.</Alert>;
    }

    return (
      <Stack spacing={1}>
        <Typography variant="body2">
          {`${hook.costLabel} utilisés sur ${hook.limitLabel} en ${hook.monthLabel} · ${hook.calls} appel${hook.calls > 1 ? 's' : ''} à l'IA`}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={hook.percent}
          color={hook.isLimitReached ? 'error' : 'primary'}
          aria-label="Part du quota IA mensuel utilisée"
        />
        {hook.isLimitReached ? (
          <Alert severity="warning">
            Quota atteint : l'assistant et l'analyse IA sont suspendus jusqu'au mois prochain.
          </Alert>
        ) : null}
      </Stack>
    );
  }

  return (
    <Card>
      <CardHeader
        title="Consommation IA"
        subheader="Assistant, indexation des documents et analyse des e-mails."
      />
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
}
